import Bloc from './Bloc.js';
import Types from './Types.js';

export default class BreakChampion extends Bloc {

	constructor (src, ctx) {

		super("breakchampion", src, ctx);
		this.f = (src, ins) => [src.master.run.champion.level + (src.master.run.traits.passive || 1) - 1 + (src.master.run.champion.getPassive("extrapassive") || 0), src.master.run.champion.exp, src.master.run.champion.hp, src.master.run.champion.maxhp, src.master.run.champion.level];
		this.types = [];
	}
}
